import { render, staticRenderFns } from "./TableColumnPlusAfter.vue?vue&type=template&id=42afbcc6"
import script from "./TableColumnPlusAfter.vue?vue&type=script&lang=js"
export * from "./TableColumnPlusAfter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports